import { render, staticRenderFns } from "./SelectPermission.vue?vue&type=template&id=447e9d38&"
import script from "./SelectPermission.vue?vue&type=script&lang=ts&"
export * from "./SelectPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports